module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-login"
  }, [_c('img', {
    staticClass: "lxm-login__background",
    attrs: {
      "src": require("../images/login/bg.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-login__container"
  }, [_c('img', {
    staticClass: "lxm-login__logo",
    attrs: {
      "src": require("../images/login/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-login-org"
  }, [_c('div', {
    staticClass: "lxm-login-org__subtitle"
  }, [_vm._v("\n        您的用户名在以下机构中，请选择：\n      ")]), _vm._v(" "), _vm._l((_vm.orgs), function(org) {
    return [_c('div', {
      staticClass: "lxm-login-org__org",
      on: {
        "click": function($event) {
          _vm.orgClicked(org)
        }
      }
    }, [_c('div', {
      staticClass: "lxm-login-org__name"
    }, [_vm._v("\n            " + _vm._s(org.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "lxm-login-org__domain"
    }, [_vm._v("\n            " + _vm._s(org.domain) + "\n          ")])])]
  })], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bc976368", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc976368!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Org.vue
// module id = 884
// module chunks = 0